let fallbackSequence = 0;

export function commandId(prefix: string): string {
  if (typeof crypto.randomUUID === "function") return `${prefix}:${crypto.randomUUID()}`;
  fallbackSequence += 1;
  return `${prefix}:${Date.now()}:${fallbackSequence}`;
}
